import React from "react";

export const LazyAssetTypesSingleSelectAutoUpdateBridge = React.lazy(
    () =>
        import(
            /* webpackChunkName: "SelectAutoUpdate" */ "./AssetTypesSingleSelectAutoUpdate"
        )
);
